

// アコーディオン（FAQ、商品詳細ページ共通）
    // $('.acc').on('click', function() {
    //     $(this).toggleClass('on').next().slideToggle();
    // });


const accordions = document.getElementsByClassName("acc");

for (let i = 0; i < accordions.length; i++) {
  accordions[i].addEventListener("click", function () {
    this.classList.toggle("on");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}